function ready(callbackFunc) {
  if (document.readyState !== 'loading') {
    // Document is already ready, call the callback directly
    callbackFunc();
  } else if (document.addEventListener) {
    // All modern browsers to register DOMContentLoaded
    document.addEventListener('DOMContentLoaded', callbackFunc);
  } else {
    // Old IE browsers
    document.attachEvent('onreadystatechange', function() {
      if (document.readyState === 'complete') {
        callbackFunc();
      }
    });
  }
}

ready(function() {
  if (document.body.classList.contains('template-product')) {
    initThumbs();
  }
});

function initThumbs() {


  document.querySelectorAll(".thumb-item").forEach( thumb => {
    thumb.addEventListener("click", function() {
      console.log("LICKEDD: ", thumb.dataset.img);
//       document.querySelector(".product-single__media-wrapper").querySelector("img").style.display = "none";
      document.querySelector(".product-single__media-wrapper").querySelector("img").remove();
      var img = document.createElement('img');
      img.src = thumb.dataset.img;
      document.querySelector(".product-single__media-wrapper").querySelector(".product-single__media").appendChild(img);
    });
  });
}
